import { em } from 'polished'
import styled, { css } from 'styled-components'

import { BaseButtonStyled } from './BaseButtonStyled'
import { buttonColorCSS } from './utils'
import { IconStyled } from '../../Icon/styles/IconStyled'
import { IconComponentStyled } from '@ui/elements/Icon/styles/IconComponentStyled'

export const IconButtonStyled = styled((props) => (
  <BaseButtonStyled role='button' {...props} />
))`
  ${(props) => {
    const button = props.theme.colors.button.icon

    return css`
      min-width: ${em(40, props.theme.fontSizes.button)};
      padding: ${em(12, props.theme.fontSizes.button)};

      ${buttonColorCSS(button, { disabled: false })}

      &:active {
        box-shadow: none;
        border-width: ${props.theme.typography.pxToRem(2)};
      }

      &[disabled] {
        cursor: not-allowed;
        color: ${button.content.disabled};
        background-color: ${button.background.default};
        border-color: ${button.border.disabled};
        box-shadow: none;

        &:hover,
        &:active {
          color: ${button.content.disabled};
          background-color: ${button.background.default};
          border-color: ${button.border.disabled};
          border-width: ${props.theme.typography.pxToRem(1)};
          box-shadow: none;
        }
      }

      > ${/* sc-selector */ IconStyled},
        > ${/* sc-selector */ IconComponentStyled} {
        margin: 0;
        font-size: ${em(11, props.theme.fontSizes.button)};

        transform: scale(1.5);
      }
    `
  }}
`
